/***       carTypeScroll        ***/
<template>
  <div class="carTypeScroll">
    <div class="Content">
      <div class="arrows arrowsLeft" @click="clickFn('left')">
        <i class="iconfont icon-jiantou"></i>
      </div>
      <div class="ScrollCont">
        <ul>
          <li class="ScrollContLi" v-for="(item,index) in carTypeDataFn.data"
              :class="action===item.index?'ScrollContLiShow':''">
            <img :src="item.imgUrl">
          </li>
        </ul>
      </div>
      <div class="arrows arrowsRight" @click="clickFn('right')">
        <i class="iconfont icon-jiantou"></i>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    components: {},
    name: 'xk-carTypeScroll',
    props: ['data'],
    computed: {
      ...mapGetters({}),
      carTypeDataFn: function () {
        let data = this.$props.data
        if (data.data && data.data.length > 0) {
          this.action = data.action
          return data
        }
      }
    },
    data () {
      return {
        action: 0
      }
    },
    watch: {},
    methods: {
      clickFn: function (type) {
        var action = this.action
        switch (type) {
          case 'left':
            action--
            if (action < 0) {
              action = this.$props.data.data.length - 1
              this.action = action
              this.$emit('click', {index: action, data: this.$props.data.data[action]})
              return false
            }
            this.action = action
            this.$emit('click', {index: action, data: this.$props.data.data[action]})
            break
          case 'right':
            action++
            if (action >= this.$props.data.data.length) {
              action = 0
              this.action = action
              this.$emit('click', {index: action, data: this.$props.data.data[action]})
              return false
            }
            this.action = action
            this.$emit('click', {index: action, data: this.$props.data.data[action]})
            break
        }
      }
    },
    mounted: function () {}
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/less" lang="less">
  .carTypeScroll {
    width: 100%;
    height: 10rem;
    .Content {
      width: 100%;
      height: 100%;
      position: relative;
      .arrows {
        position: absolute;
        z-index: 10;
        i {
          font-size: 2rem;
          color: rgba(0, 0, 0, .5);
        }
      }
      .arrowsLeft {
        left: 0;
        top: 50%;
        transform: translate(0, -50%) rotate(180deg);
      }
      .arrowsRight {
        right: 0;
        top: 50%;
        transform: translate(0, -50%);
      }
      .ScrollCont {
        position: relative;
        width: 100%;
        height: inherit;
        ul {
          width: 100%;
          height: 100%;
          overflow: hidden;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          li {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            transition: 0.3s all;
            opacity: 0;
            img {
              width: 100%;
            }
          }
          .ScrollContLiShow {
            opacity: 1;
          }
        }
        .ScrollContLi {

        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// carTypeScroll.vue?0eb4715c